<script setup lang="ts">
import type { Project } from "@/types/projects.types";

withDefaults(
  defineProps<{
    project: Partial<Project>;
    size?: number;
  }>(),
  {
    size: 40,
  }
);
</script>

<template>
  <div
    class="p-2 rounded d-flex flex-column justify-content-center align-items-center"
    :style="{
      background: `${project.color}${20}`,
      width: `${size}px`,
      height: `${size}px`,
    }"
  >
    <i
      class="bi-folder-fill"
      :style="{
        color: project.color,
        fontSize: `${size * 0.5}px`,
      }"
    ></i>
  </div>
</template>

<style lang="scss" scoped></style>
